function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment } from 'react';
import { componentsThemeMap, colorToVariable } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import '../../ui/Image/index.js';
import '../../ui/Link/index.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Link } from '../../ui/Link/Link.js';
import { Image } from '../../ui/Image/Image.js';
function AvatarCard({
  headline,
  subtext,
  gridRow,
  label,
  url,
  icon,
  style,
  imageFit,
  imageSrc,
  imageAlt
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    borderLine = _componentsThemeMap$s.borderLine,
    primary = _componentsThemeMap$s.primary;
  const linkWrapperProps = url && {
    href: url,
    'data-qa': ANALYTICS_KEY.AvatarCard
  };
  const LinkWrapper = url ? LinkPressable : Fragment;
  return /*#__PURE__*/jsxs(Div, {
    width: 232,
    alignItems: "center",
    flexDirection: "column",
    css: {
      textAlign: 'center'
    },
    gridRow: {
      lg: gridRow || 'auto'
    },
    children: [/*#__PURE__*/jsx(Link, {
      href: url,
      "data-qa": ANALYTICS_KEY.AvatarCard,
      children: /*#__PURE__*/jsx(Image, {
        css: {
          borderRadius: '50%',
          border: '1px solid',
          borderColor: colorToVariable(borderLine || 'line'),
          padding: 12,
          img: {
            borderRadius: '50%'
          }
        },
        imageFit: imageFit,
        src: imageSrc,
        alt: imageAlt || label,
        borderRadius: "roundedFull",
        maxWidth: {
          sm: 180,
          md: 230
        },
        height: {
          sm: 180,
          md: 230
        }
      })
    }), /*#__PURE__*/jsxs(Div, {
      spacingTop: 3,
      flexDirection: "column",
      alignItems: "center",
      children: [/*#__PURE__*/jsx(LinkWrapper, _objectSpread(_objectSpread({}, linkWrapperProps), {}, {
        children: /*#__PURE__*/jsxs(Div, {
          alignItems: "center",
          children: [icon, /*#__PURE__*/jsx(Text, {
            variant: "label1",
            color: primary,
            spacingStart: 1,
            children: label
          })]
        })
      })), /*#__PURE__*/jsx(Text, {
        variant: "label2",
        spacingTop: 0.5,
        color: foregroundSecondary,
        css: {
          whiteSpace: 'pre-line'
        },
        children: headline
      }), /*#__PURE__*/jsx(Text, {
        variant: "legal",
        spacingTop: 0.5,
        color: foregroundSecondary,
        css: {
          whiteSpace: 'pre-line',
          fontStyle: 'italic'
        },
        children: subtext
      })]
    })]
  });
}
export { AvatarCard };
//# sourceMappingURL=AvatarCard.js.map
